import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from "react";
import { WidgetI18nContext } from "./context/WidgetI18nContext";
export class WidgetErrorBoundary extends Component {
    static contextType = WidgetI18nContext;
    state = {
        hasError: false,
        error: null,
    };
    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }
    componentDidCatch(error, info) {
        this.props.onError?.(error, info);
    }
    handleRetry = () => {
        this.setState({ hasError: false, error: null });
        this.props.onRetry?.();
    };
    render() {
        if (this.state.hasError) {
            return (_jsxs("div", { role: "alert", style: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 12,
                    minHeight: 240,
                    padding: 24,
                    borderRadius: 16,
                    background: "rgba(15, 23, 42, 0.04)",
                    color: "#b91c1c",
                    fontSize: 14,
                    fontWeight: 600,
                    textAlign: "center",
                }, children: [_jsx("span", { children: this.context.t("widget.error") }), _jsx("button", { type: "button", onClick: this.handleRetry, style: {
                            padding: "8px 16px",
                            borderRadius: 8,
                            border: "1px solid currentColor",
                            background: "transparent",
                            color: "inherit",
                            fontSize: 13,
                            fontWeight: 600,
                            cursor: "pointer",
                        }, children: this.context.t("error.retry") })] }));
        }
        return this.props.children;
    }
}
